import type { Operation } from '@/util/roles/generated'
import useAuthStore from '@/stores/auth'
import type { Capability } from '@/util/roles/capabilities'
import { computed, type ComputedRef } from 'vue'

/**
 * Reactive access check. Accepts either a named capability
 * (`useCan('manageVrfs')`) or a raw guarded operation (`useCan('vrfsPost')`).
 * Returns a `ComputedRef<boolean>` that tracks the current user's roles.
 */
export default function useCan(
  target: Capability | Operation,
): ComputedRef<boolean> {
  const store = useAuthStore()
  return computed(() => store.can(target))
}
